import { render, staticRenderFns } from "./DraftDescription.vue?vue&type=template&id=04525de0&"
import script from "./DraftDescription.vue?vue&type=script&lang=js&"
export * from "./DraftDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports